module.exports = __webpack_public_path__ + "img/tanglei.13fe09ad.png";